import { d as n } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var _ = {
  name: "ss",
  weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),
  months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),
  weekStart: 1,
  weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
  monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
  weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
  ordinal: function(a) {
    return a;
  },
  formats: {
    LT: "h:mm A",
    LTS: "h:mm:ss A",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY h:mm A",
    LLLL: "dddd, D MMMM YYYY h:mm A"
  },
  relativeTime: {
    future: "nga %s",
    past: "wenteka nga %s",
    s: "emizuzwana lomcane",
    m: "umzuzu",
    mm: "%d emizuzu",
    h: "lihora",
    hh: "%d emahora",
    d: "lilanga",
    dd: "%d emalanga",
    M: "inyanga",
    MM: "%d tinyanga",
    y: "umnyaka",
    yy: "%d iminyaka"
  }
};
n.locale(_, null, !0);
export {
  _ as default
};
